"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoRooms/AdminPreview.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _AdminPreview = require('web/components/VideoRooms/Room/AdminPreview'); var _AdminPreview2 = _interopRequireDefault(_AdminPreview);
var _user = require('shared/selectors/user');
var _peers = require('shared/selectors/peers');
var _org = require('shared/selectors/org');
var _team = require('shared/selectors/team');



var _hooks = require('web/services/hooks');

// The room's admin lists hold plain strings; the selectors below take the
// store's branded keys, which are the same strings.











const noUser = {}

// memo keeps connect()'s bailout on unchanged own props.
 const AdminUserPreview = _react.memo.call(void 0, function AdminUserPreview ({
  userKey, orgKey, onRemove,
}) {
  // SAFETY: the admin lists hold store user keys, as plain strings.
  const storeUserKey = userKey 
  // SAFETY: an org key as a plain string; as in the JS, a missing one finds
  // no org.
  const storeOrgKey = orgKey 
  const user = _hooks.useAppSelector.call(void 0, state => _peers.selectUserByKey.call(void 0, state, storeUserKey))
  const orgName = _hooks.useAppSelector.call(void 0, state => _optionalChain([_org.selectOrgByKey.call(void 0, storeOrgKey, state), 'optionalAccess', _ => _.Name]))
  const isMe = _hooks.useAppSelector.call(void 0, state => _user.selectCurrentUserKey.call(void 0, state) === userKey)

  // As in the JS, a missing user falls back to an empty entity, so the
  // preview always renders (the `!user` guard never applied).
  return (
    _react2.default.createElement(_AdminPreview2.default, {
      adminEntity: user || noUser,
      isMe: isMe,
      orgName: orgName,
      onRemove: onRemove, __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
    )
  )
}); exports.AdminUserPreview = AdminUserPreview

 const AdminTeamPreview = _react.memo.call(void 0, function AdminTeamPreview ({
  teamKey, onRemove,
}) {
  // SAFETY: the admin lists hold store team keys, as plain strings.
  const storeTeamKey = teamKey 
  const team = _hooks.useAppSelector.call(void 0, state => _team.selectTeamByKey.call(void 0, state, storeTeamKey))
  const orgName = _hooks.useAppSelector.call(void 0, state => {
    const teamOrgKey = _optionalChain([_team.selectTeamByKey.call(void 0, state, storeTeamKey), 'optionalAccess', _2 => _2.OrgKey])
    // SAFETY: as in the JS, a missing team looks up an undefined org key,
    // which finds no org.
    const storeOrgKey = teamOrgKey 
    return _optionalChain([_org.selectOrgByKey.call(void 0, storeOrgKey, state), 'optionalAccess', _3 => _3.Name])
  })

  if (!team) return null

  return (
    _react2.default.createElement(_AdminPreview2.default, {
      adminEntity: team,
      orgName: orgName,
      onRemove: onRemove, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
    )
  )
}); exports.AdminTeamPreview = AdminTeamPreview
